import { useQuery } from '@apollo/client';
import { useRouter } from 'next/router';
import React, { useEffect } from 'react';

import { fullstoryScript } from '@/lib/fullstory';
import { AppContext, AppContextQueryData } from '@/queries/AppContext';
import { FullStoryConfig } from '@/types/FullStoryConfig';

const FullStoryInitializer: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const { pathname } = useRouter();
  const { data } = useQuery<AppContextQueryData>(AppContext);

  const isPreviewRoute = pathname.includes('/preview');

  const fullstoryThinkific = (
    user: AppContextQueryData['me'],
    site: AppContextQueryData['site']
  ): FullStoryConfig => ({
    fsDebug: process.env.NEXT_PUBLIC_FULLSTORY_DEBUG || '',
    fsOrg: process.env.NEXT_PUBLIC_FULLSTORY_ORG || '',
    userId: user?.id || '',
    displayName: user?.fullName || '',
    email: user?.email || '',
    tenantSubdomain: site?.subdomain || '',
    tenantName: site?.name || '',
    namespace: isPreviewRoute ? 'FullstoryPreview' : 'FS',
  });

  useEffect(() => {
    if (!data) return;
    if (data?.site?.fullstoryEnabled === true) {
      if (!document.querySelector('script[data-fullstory]')) {
        const { me: user, site } = data;
        const fullstoryData = fullstoryThinkific(user, site);

        const script = document.createElement('script');
        script.textContent = fullstoryScript(fullstoryData);
        script.setAttribute('data-fullstory', 'true');
        document.head.appendChild(script);
      }
    }
  }, [data]);

  return <>{children}</>;
};

export default FullStoryInitializer;
